import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/terms",
    name: "terms",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/TermsAndConditions.vue"),
  },
  {
    path: "/referrals",
    name: "referrals",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Referrals.vue"),
  },
  {
    path: "/referral-start",
    name: "referral-start",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/ReferralStart.vue"),
  },
  {
    path: "/privacy",
    name: "privacy",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PrivacyPolicy.vue"),
  },
  {
    path: "/recently-closed",
    name: "recently-closed",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RecentlyClosed.vue"),
  },
  {
    path: "/profile",
    name: "profile",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Profile.vue"),
  },
  {
    path: "/update-avatar",
    name: "update-avatar",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UpdateAvatar.vue"),
  },
  {
    path: "/session-set",
    name: "session-set",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SessionSet.vue"),
  },
  {
    path: "/session-unset",
    name: "session-unset",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/SessionUnSet.vue"),
  },
  {
    path: "/purchase-tokens",
    name: "purchase-tokens",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PurchaseTokens.vue"),
  },
  {
    path: "/unsubscribe",
    name: "unsubscribe",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Unsubscribe.vue"),
  },
  {
    path: "/notifications-preferences",
    name: "notifications-preferences",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/NotificationsPreferences.vue"),
  },
  {
    path: "/checkout/:id",
    name: "checkout",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Checkout.vue"),
  },
  {
    path: "/payment-methods",
    name: "payment-methods",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PaymentMethods.vue"),
  },
  {
    path: "/payment-methods-add",
    name: "payment-methods-add",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PaymentMethodsAdd.vue"),
  },
  {
    path: "/auctions-won",
    name: "auctions-won",
    beforeEnter: requireAuth,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AuctionsWon.vue"),
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contact.vue"),
  },
  {
    path: "/how-it-works",
    name: "how-it-works",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HowItWorks.vue"),
  },
  {
    path: "/partner-with-us",
    name: "partner-with-us",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/PartnerWithUs.vue"),
  },
  {
    path: "/redeem-coupon",
    name: "redeem-coupon",
    beforeEnter: requireAuth,
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/RedeemCoupon.vue"),
  },
  {
     path: "/customer-stories",
     name: "customer-stories",
     component: () =>
       import( /* webpackChunkName: "about" */ "../views/CustomerStories.vue"),
   },
   {
    path: "/welcome",
    name: "welcome",
    component: () =>
      import( /* webpackChunkName: "about" */ "../views/Welcome.vue"),
    },
  {
    path: "/auctions/:id",
    component: () => import("../views/Auction.vue"),
  },
];

function requireAuth(to, from, next) {
  if (store.state.isAuthenticated) {
    next();
  } else {
    next({
      name: "home",
      query: { redirect: to.fullPath },
    });
  }
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});
export default router;
